export enum AddonKey {
    Baa = 'baa',
    Premiumgeodb = 'premiumgeodb',
    Premiumgeodborg = 'premiumgeodborg',
    BackupRecovery = 'backup_recovery',
}
